import { createBlock as t, openBlock as r, Transition as i, withCtx as l, createElementVNode as o, normalizeClass as d, renderSlot as s } from "vue";
/* empty css                                           */
import n from "../../../_virtual/_plugin-vue_export-helper.js";
const c = {
  name: "DsHeaderNavigationVerticalSlideOver",
  props: {
    withShadow: { type: Boolean, default: !1 },
    widthFull: { type: Boolean, default: !1 }
  }
};
function h(a, f, e, v, p, u) {
  return r(), t(i, {
    name: "ds-header-vertical-slide-over__transition",
    appear: ""
  }, {
    default: l(() => [
      o("div", {
        class: d(["ds-header-vertical-slide-over", [
          { "ds-header-vertical-slide-over--with-shadow": e.withShadow },
          { "ds-header-vertical-slide-over--width-full": e.widthFull }
        ]]),
        "data-j-content": ""
      }, [
        s(a.$slots, "default")
      ], 2)
    ]),
    _: 3
  });
}
const S = /* @__PURE__ */ n(c, [["render", h]]);
export {
  S as default
};
